<template>
  <div class="zujianBox">
    <div class="boxA" >
        <div class="boxAcont">
            <div class="itemA">
              <p class="name color1">{{totalData.weightSum}}</p>
              <p class="name1">历史发运量总计(吨)</p>
            </div>
            <div class="itemA">
              <p class="name color1">{{totalData.carSum}}</p>
              <p class="name1">历史发车次总计(次)</p>
            </div>
        </div>
      </div>
      <div class="zjBottom">
        <el-row :gutter="12">
          <el-col :span="6">
            <div class="boxA">
            <div class="left_h">
              <span class="span_one">当日拉运量对比(吨)</span>
            </div>
            <div class="boxAcont" id="pie1">

            </div>
          </div>
          </el-col>
          <el-col :span="6">
            <div class="boxA">
            <div class="left_h">
              <span class="span_one">当日发车次对比(次)</span>
            </div>
            <div class="boxAcont" id="pie2">

            </div>
          </div>
          </el-col>
          <el-col :span="12" class="column">
            <div class="boxA" style="margin-bottom:12px">
              <div class="left_h">
                <span class="span_one">各车队拉运情况</span>
              </div>
              <div class="boxAcont" id="myChart">

              </div>
            </div>
            <div class="boxA">
              <div class="left_h">
                <span class="span_one">日配货量趋势</span>
              </div>
              <div class="boxAcont" id="idChart">

              </div>
            </div>
          </el-col>
        </el-row>

      </div>
  </div>
</template>
<script>
import { carTotal, fleetData, distributiogData } from '@/api/data-center-server'
export default {
  data () {
    return {
      totalData: {}
    }
  },
  created () {

  },
  mounted () {
    this.getdata()
    this.fleetDataS()
    this.distributiogDataS()
  },
  methods: {
    getdata () {
      carTotal({ }).then(res => {
        this.totalData = res
        // 柱状图数据
        // var valueData1 = []
        // var valueData2 = []
        // var nameData = []
        // res.list.forEach((item, index) => {
        //   nameData.push(item.tenantName)
        //   valueData1.push(item.weightTotal)
        //   valueData2.push(item.carTotal)
        // })
        // this.zhuChart(nameData, valueData1, 'zhu1', '拉运量')
        // this.zhuChart(nameData, valueData2, 'zhu2', '发车次')
        this.pie(res.list, 'dailyWeight', '当日拉运量', 'pie1')
        this.pie(res.list, 'dailyCar', '当日发车次', 'pie2')
      })
    },
    // 5-波动(日配货量趋势)
    distributiogDataS () {
      let _this = this
      distributiogData({})
        .then(res => {
          _this.gcListData = [] // 钢厂
          _this.ptListData = [] // 平台
          _this.hjListData = [] // 合计
          // 钢厂配货 车队配货 合计配货
          _this.distriListData = res

          // 时间
          _this.shijianListData = Object.keys(res.x7).sort()

          _this.shijianListData.forEach((item, index) => {
            _this.gcListData.push(res.x10[item] ? res.x10[item] : 0)
            _this.ptListData.push(res.x7[item] ? res.x7[item] : 0)
            _this.hjListData.push(res.x0[item] ? res.x0[item] : 0)
          })
          let shijianData = _this.shijianListData
          _this.shijianListData = []

          shijianData.forEach((item, index) => {
            item = item.slice(5)
            _this.shijianListData.push(item)
          })

          // 数组的最大下标
          let maxIndex = _this.shijianListData.length - 1
          // 获取长度-累加器
          let tempEndIndex = maxIndex > 6 ? 6 : maxIndex
          // 对数据进行处理(截取->折线图数据初始化长度)
          let tempGcListData = _this.gcListData.slice(0, tempEndIndex)
          let tempPtListData = _this.ptListData.slice(0, tempEndIndex)
          let tempHjListData = _this.hjListData.slice(0, tempEndIndex)
          let tempShijianListData = _this.shijianListData.slice(
            0,
            tempEndIndex
          )
          // console.log(tempGcListData,)
          //= ===
          // 基于准备好的dom，初始化echarts实例
          let idChart = _this.$echarts.init(document.getElementById('idChart'))
          // idChart.init(document.getElementById('idChart')).dispose()// 销毁前一个实例
          // idChart = _this.$echarts.init(document.getElementById('idChart'))// 构建下一个实例

          // 绘制图表--折线图
          var idChartOption = {
            // title: {
            //   text: "折线图堆叠"
            // },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['钢厂配货', '车队配货', '合计配货'],
              color: ['#fff'],
              textStyle: {
                color: '#fff'
              }
            },
            grid: {
              left: '2%',
              right: '6%',
              bottom: '10%',
              containLabel: true
            },
            // toolbox: {
            //   feature: {
            //     saveAsImage: {} 下载按钮
            //   }
            // },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: tempShijianListData,
              // 横坐标轴颜色
              axisLine: {
                lineStyle: {
                  color: '#14D5FF'
                }
              },
              axisLabel: {
                interval: 0
              }
            },
            yAxis: {
              type: 'value',
              max: '50000',
              // 横坐标轴颜色
              axisLine: {
                lineStyle: {
                  color: '#14D5FF'
                }
              },
              splitLine: {
                lineStyle: {
                  color: '#14D5FF'
                }
              }
            },
            series: [
              {
                name: '钢厂配货',
                type: 'line',
                color: '#14D5FF',
                data: tempGcListData
              },
              {
                name: '车队配货',
                type: 'line',
                color: '#E09C13',
                data: tempPtListData
              },
              {
                name: '合计配货',
                type: 'line',
                color: '#FF4520',
                data: tempHjListData
              }
            ]
          }
          idChart.setOption(idChartOption)
          // 定时器-控制折线图x轴数据变化
          this.intChange = setInterval(function () {
            //
            if (tempEndIndex > maxIndex) {
              idChartOption.series[0].data = []
              idChartOption.series[1].data = []
              idChartOption.series[2].data = []
              idChart.setOption(idChartOption)

              tempEndIndex = maxIndex > 6 ? 6 : maxIndex
              idChartOption.series[0].data = _this.gcListData.slice(
                0,
                tempEndIndex
              )
              idChartOption.series[1].data = _this.ptListData.slice(
                0,
                tempEndIndex
              )
              idChartOption.series[2].data = _this.hjListData.slice(
                0,
                tempEndIndex
              )
              idChartOption.xAxis.data = _this.shijianListData.slice(
                0,
                tempEndIndex
              )
              idChart.setOption(idChartOption)
            } else {
              // 时间
              var axisData = _this.shijianListData[tempEndIndex]
              var data1 = _this.gcListData[tempEndIndex]
              var data2 = _this.ptListData[tempEndIndex]
              var data3 = _this.hjListData[tempEndIndex]
              // 移除开头第一条数据(x轴数据)
              idChartOption.series[0].data.shift()
              idChartOption.series[1].data.shift()
              idChartOption.series[2].data.shift()
              idChartOption.xAxis.data.shift()

              idChartOption.series[0].data.push(data1)
              idChartOption.series[1].data.push(data2)
              idChartOption.series[2].data.push(data3)
              idChartOption.xAxis.data.push(axisData)
              idChart.setOption(idChartOption)
            }
            tempEndIndex++
          }, 3000)
          console.log(tempEndIndex, 'tempEndIndex')
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 3-车队拉运量
    fleetDataS () {
      fleetData({})
        .then(res => {
          this.jiahuaData = []
          this.layunData = []
          this.shenyuData = []
          this.nameData = []
          this.fleetListData = res
          this.fleetListData.forEach((item, index) => {
            this.nameData.push(item.name)
            // 计划吨数
            this.jiahuaData.push(item.planNum)
            // 拉运吨数
            this.layunData.push(item.completeNum)
            // 剩余吨数
            this.shenyuData.push(item.remainNum)
          })
          let myChart = this.$echarts.init(document.getElementById('myChart'))

          // 柱状图数据
          var map4Data1 = this.jiahuaData
          var map4Data2 = this.layunData
          var map4Data3 = this.shenyuData
          // 绘制图表--柱状
          myChart.setOption({
            color: ['#0DD9FE', '#52F23A', '#FFAF03'],
            // backgroundColor: "#323a5e",
            grid: {
              left: '2%',
              right: '4%',
              bottom: '9%',
              top: '25%',
              containLabel: true
            },
            legend: {
              icon: 'circle',
              data: ['日计划吨数', '日拉运吨数', '日剩余吨数'],
              textStyle: {
                color: '#fff'
              }
            },
            // ---  提示框 ----
            tooltip: {
              show: true, // 是否显示提示框，默认为true
              trigger: 'item', // 数据项图形触发
              axisPointer: {
                // 指示样式
                type: 'shadow',
                axis: 'auto'
              },
              padding: 5,
              textStyle: {
                // 提示框内容的样式
                color: '#fff'
              }
            },
            calculable: true,
            xAxis: {
              type: 'category',
              data: this.nameData,
              axisLine: {
                lineStyle: {
                  color: 'white'
                }
              },
              axisLabel: {
                // interval: 0,
                // rotate: 40,
                textStyle: {
                  fontFamily: 'Microsoft YaHei'
                }
              }
            },
            yAxis: {
              type: 'value',
              data: ['2000', '4000', '6000', '8000'],
              axisLine: {
                show: false,
                lineStyle: {
                  color: 'white'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(255,255,255,0.3)'
                }
              },
              axisLabel: {}
            },
            series: [
              {
                name: '日计划吨数',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: map4Data1
              },
              {
                name: '日拉运吨数',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: map4Data2
              },
              {
                name: '日剩余吨数',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: map4Data3
              }
            ]
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    pie (data, value, name, id) {
      let _this = this
      var img = 'data:image/png;base64,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'
      let idChart = _this.$echarts.init(document.getElementById(id))
      var dataArr = []
      var color = ['#00ffff', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000', '#00cfff']
      for (var i = 0; i < data.length; i++) {
        dataArr.push({
          value: data[i][value],
          name: data[i].tenantName,
          itemStyle: {
            normal: {
              borderWidth: 5,
              shadowBlur: 20,
              borderColor: color[i],
              shadowColor: color[i]
            }
          }
        }, {
          value: 1,
          name: '',
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              color: 'rgba(0, 0, 0, 0)',
              borderColor: 'rgba(0, 0, 0, 0)',
              borderWidth: 0
            }
          }
        })
      }
      var seriesOption = [{
        name: '',
        type: 'pie',
        clockWise: false,
        radius: [70, 75],
        hoverAnimation: false,
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'outside',
              color: '#ddd',
              formatter: function (params) {
                if (params.name) {
                  let valueTxt = ''
                  if (params.name.length > 5) {
                    valueTxt = params.name.substring(0, 6) + '...' // 想要展示的x轴名称长度
                  } else {
                    valueTxt = params.name
                  }
                  return valueTxt + '：' + params.value
                }
              }
            }
          }
        },
        data: dataArr
      }]
      var option = {
        backgroundColor: 'rgba(225,225,225,0)',
        color: color,
        title: {
          text: name,
          top: '48%',
          textAlign: 'center',
          left: '49%',
          textStyle: {
            color: '#fff',
            fontSize: 18,
            fontWeight: '400'
          }
        },
        graphic: {
          elements: [{
            type: 'image',
            z: 3,
            style: {
              image: img,
              width: 128,
              height: 128
            },
            left: 'center',
            top: 'center',
            position: [100, 100]
          }]
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.5)',
          formatter: function (params) {
            var percent = 0
            var total = 0
            for (var i = 0; i < data.length; i++) {
              if (data[i][value]) {
                total += data[i][value]
              }
            }
            if (total == 0) {
              percent = 0
            } else {
              percent = ((params.value / total) * 100).toFixed(0)
            }

            return params.marker + '<span style="color:' + params.color + '">' + params.data['name'] + '\n' + params.data['value'] + '</span></br>' + '占百分比：' + percent + '%'
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        series: seriesOption
      }
      idChart.setOption(option)
    },
    zhuChart (nameData, valueData, id, name) {
      let myChart = this.$echarts.init(document.getElementById(id))
      // 绘制图表--柱状
      myChart.setOption({
        color: ['#0DD9FE', '#52F23A'],
        // backgroundColor: "#323a5e",
        grid: {
          left: '2%',
          right: '4%',
          bottom: '5%',
          top: '10%',
          containLabel: true
        },
        legend: {
          icon: 'circle',
          data: [name],
          textStyle: {
            color: '#fff'
          }
        },
        // ---  提示框 ----
        tooltip: {
          show: true, // 是否显示提示框，默认为true
          trigger: 'item', // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: 'shadow',
            axis: 'auto'
          },
          formatter: function (value) {
            return value.marker + value.seriesName + '：' + value.value
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: '#fff'
          }
        },
        calculable: true,
        xAxis: {
          type: 'category',
          data: nameData,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            interval: 0,
            rotate: 25,
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            },
            formatter: function (data) {
              let valueTxt = ''
              if (data.length > 5) {
                valueTxt = data.substring(0, 6) + '...' // 想要展示的x轴名称长度
              } else {
                valueTxt = data
              }
              return valueTxt
            }
          }
        },
        yAxis: {
          type: 'value',
          data: ['2000', '4000', '6000', '8000'],
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        series: [
          {
            name: name,
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: valueData
          }
        ]
      })
    }
  },
  computed: {

  },
  filters: {

  },
  destroyed () {
    clearInterval(this.nowTimer)
    clearInterval(this.mapTimer)
  }
}
</script>

<style lang="less" scoped>

.zujianBox{
  height: 100%;
  width: 100%;
  display: flex;
 flex-direction: column;
  .boxAcont{
    padding: 12px 0;
  }
}
.zjBottom{
  flex: 1;
  margin-top: 12px;
  .boxA{
    height: 100%;
  }
}
.column {
  .boxA{
    height:calc(50% - 6px);
  }
}

/deep/.el-row{
  height: 100%;
  display: flex;
  .el-col{
  height: 100%;
  }
}
.boxA{
    width: 100%;
    border: 1px solid #045f59;
    box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75) inset;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .boxAcont{
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex: 1;
      text-align: center;
      .name{
        font-size: 24px;
        margin-bottom: 10px;
      }
      .name1{
        color: #ffffff;
        font-size: 12px;
      }
      p{
        margin: 0;
      }
    }
}
.left_h {
  height: 40px;
  line-height: 40px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
  background: rgba(41, 139, 208, 0.3);
  box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75);
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 16px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}
.color1{
    color: #03faec;
}
.color2{
    color: #ffa500;
}
.color3{
    color: #4df442;
}
.color4{
    color: #2e9cfd;
}
.color5{
    color: #fffc0d;
}
</style>
